import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFooterContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing['10'],
    backgroundColor: theme.colors.WHITE,
    marginTop: 'auto',
    paddingHorizontal: theme.spacing['10'],
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['8'],
    ...theme.elevations['12'],
  },
});
